/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Settings } from "@material-ui/icons";
import { useIsPageActive } from "../../../../../hooks/utils";
import { getIconCss } from "../../styles";
import { SettingsLink } from "./styles";

const Administration = () => {
  const isAdministrationActive = useIsPageActive("administration");

  return (
    <SettingsLink to="/administration" data-cy="settings-icon">
      <Settings css={getIconCss(isAdministrationActive)} />
    </SettingsLink>
  );
};

export default Administration;
